import React, { ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";
import "./Modal.scss";
import { FocusTrap } from "@me8eon/focus_trap";
import { useTheme, CSSVariables } from "@me8eon/themes";
import { Icon } from "@me8eon/icons";

interface ModalProps {
    children: ReactNode;
    toggleModal: boolean;
    closeModal: () => void;
    isCloseIcon: boolean;
    modalClass?: string;
    closeOnBackdrop?: boolean;
}

export default function Modal({
    children,
    toggleModal,
    closeModal,
    isCloseIcon,
    modalClass,
    closeOnBackdrop,
}: ModalProps) {
    const theme = useTheme();
    const orgName = theme.value;
    document.getElementsByTagName("body")[0].style.overflow = toggleModal
        ? "hidden"
        : "auto";

    useEffect(() => {
        const elem = document.getElementById("startFocusHere");
        if (elem) {
            elem?.remove();
        }
    }, [toggleModal]);

    const globalCSSvariables: CSSVariables = {
        ...theme.dataLayout.colorVariables,
    };

    if (!toggleModal) return null;

    return ReactDOM.createPortal(
        <FocusTrap>
            <div
                className={`myhelp-modal ${modalClass} org-scheme org-scheme-${orgName}`}
                data-role="dialog"
                onClick={() => {
                    if (closeOnBackdrop) {
                        closeModal();
                    }
                }}
                style={globalCSSvariables}
            >
                <div
                    className="myhelp-modal-container"
                    onClick={(e) => e.stopPropagation()}
                >
                    <input id="startFocusHere" autoFocus />
                    {isCloseIcon ? (
                        <div className="close" aria-hidden="true">
                            <button
                                className="close-icon-button"
                                onClick={closeModal}
                            >
                                <Icon name="close" />
                            </button>
                        </div>
                    ) : null}
                    {children}
                </div>
            </div>
        </FocusTrap>,
        document.getElementById("modal-content-component")!,
    );
}
